import { render, staticRenderFns } from "./NavSubButton.vue?vue&type=template&id=ec3d2d68&scoped=true&"
import script from "./NavSubButton.vue?vue&type=script&lang=js&"
export * from "./NavSubButton.vue?vue&type=script&lang=js&"
import style0 from "./NavSubButton.vue?vue&type=style&index=0&id=ec3d2d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3d2d68",
  null
  
)

export default component.exports